export const FONTS = 'fonts';
export const MASKING = 'masking';
export const BLOCKLISTS = 'blacklists';
export const OVERLAID_TEXT = 'overlaid_text';
export const EDITED_TEXT = 'edited_text';
export const FINGERPRINT = 'fingerprint';
export const DATE_METADATA = 'date_metadata';
export const QPDF = 'qpdf';
export const EXIF_DATA_MODIFIED = 'exif_data_modified';
export const EDITED_WHILE_SCANNED = 'edited_while_scanned';
export const HIGH_USER_ACCESS = 'high_user_access';
export const ADOBE_FONTS = 'adobe_fonts';
export const ANNOTATION_DATES = 'annotation_dates';
export const ANNOTATIONS = 'annotations';
export const MALFORMED_DATE = 'malformed_date';
export const REJECTED_CUSTOMER = 'rejected_customer';
export const TEMPLATES = 'templates';
export const TEXT_COMPRESSION = 'text_compression';
export const TEXT_LAYER_TEXT = 'text_layer_text';
export const CUSTOM_RULES = 'rules';
export const TOUCHUP_TEXT = 'touchup_text';
export const SOFTWARE_BLOCKLIST = 'software_blacklist';
export const SEEN_BEFORE = 'seen_before';
export const XRAY = 'xray';
export const FLATTENED_PDF = 'flattened_pdf';
export const BRUSH_DETECTION = 'brush_detection';
export const PDF_ALIGNMENT = 'pdf_alignment';
export const COPYCAT_IMAGE = 'copycat_image';
export const COPYCAT_TEXT = 'copycat_text';
export const FONT_ANOMALY = 'font_anomaly';
export const METADATA_ANOMALY = 'metadata_anomaly';
export const NAME_FORMAT_ANOMALY = 'name_format_anomaly';
export const ADDRESS_FORMAT_ANOMALY = 'address_format_anomaly';
export const DATE_FORMAT_ANOMALY = 'date_format_anomaly';
export const AMOUNT_FORMAT_ANOMALY = 'amount_format_anomaly';
export const REPEAT_APPLICATION = 'repeat_application';
export const REPEAT_APPLICATION_DIFFERENT_ADDRESS =
  'repeat_application_different_address';
export const REPEAT_APPLICATION_DIFFERENT_NAME =
  'repeat_application_different_name';
export const REPEAT_APPLICATION_PREVIOUS_FRAUD =
  'repeat_application_previous_fraud';
export const REPEAT_APPLICATION_PREVIOUS_REJECTION =
  'repeat_application_previous_rejection';

export const ADDRESS = 'address';
export const NAME = 'name';
export const COMPANY = 'company';
export const ID_NUMBER = 'id_number';
export const STRINGS = 'strings';
